import React, {useState, useEffect} from 'react';
import axiosClient from '../data/axiosClient';
import styles from './Training.module.scss';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import sharedStyles from "../containers/sharedPageStyles.module.scss";
import {Container, Box, Typography } from '@mui/material';
import TrainingItem from './TrainingItem';

const Training = (props) => {
  const [listData, setListData] = useState([]);

  useEffect(() => {

    const today = getDate();

    axiosClient.get(`/training?date=${today}`, {})
      .then(function(response) {
        // if we've called the api already, let's cache the results on this class
        setListData([...response.data.training]);
      })
      .catch(error => {
        console.log(error);
      });

  }, []);

  const getDate = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${year}-${month}-${date}`;
  };

  return (

    <Container maxWidth="lg">
      <Box sx={{ width: '100%' }}>
        <div className={sharedStyles.descriptionArea}>
          <div className={sharedStyles.headerSection}>
            <Typography variant="h4">Education/Training Available</Typography>
            <div >
              <Typography sx={{pt: 2, m: 2, fontWeight: 700}}>
                ARMonline Help Desk
              </Typography>
              <Typography sx={{pt: 0, m: 2, fontWeight: 400}}>
                For specific questions about using the ARMonline tools, please feel 
                free to write us a message using our discord channel: 
                <a href="https://discord.gg/emqKSZJzk8" target="_blank" rel="noreferrer">
                  <span style={{color:"white", paddingLeft: "5px"}}>
                  https://discord.gg/emqKSZJzk8
                  </span>
                </a>
              </Typography>
            </div>
            <div className={styles.listContainer}>
              <List >
                {listData.map(item => (
                  <ListItem key={item.id} >
                    <TrainingItem
                      Id={item.id}
                      Title={item.Title}
                      Duration={item.TrainingTime}
                      URL={item.URL}
                      Tooltip={item.ToolTip} 
                      TrainingDate={item.TrainingDate}
                      TrainingTime={item.TrainingTime}
                      Cost={item.Cost}
                      Venue={item.Venue}
                      Registration={item.Registration}
                      BackgroundImage={item.BackgroundImage}
                      AddedDate={item.AddedDate}
                    />
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
        </div>
      </Box>
    </Container>
  );
}

export default Training;
